package app.nestbridge.app.di

import app.nestbridge.config.BuildKonfig
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesTo
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

data class ClientApiConfig(
    val identityServiceUrl: String,
    val childServiceUrl: String,
)

@ContributesTo(AppScope::class)
interface ApiClientModule {

    @SingleIn(AppScope::class)
    @Provides
    fun provideClientApiConfig(): ClientApiConfig =
        ClientApiConfig(
            identityServiceUrl = BuildKonfig.identityServiceUrl,
            childServiceUrl = BuildKonfig.childServiceUrl,
        )
}
